/**
 * 认证相关的工具函数
 */
import Cookies from 'js-cookie'
import store from '@/store'

/**
 * 完全清除管理员登录状态
 */
export function clearAdminSession() {
    // 清除cookies
    Cookies.remove('admin_token')
    Cookies.remove('admin_user')

    // 清除localStorage中的记住密码信息
    localStorage.removeItem('adminRememberedUsername')
    localStorage.removeItem('adminRememberedPassword')
    localStorage.removeItem('adminRememberPassword')

    // 清除store中的管理员状态
    store.dispatch('logout')

    console.log('管理员会话已完全清除')
}

/**
 * 验证token是否有效
 */
export function isValidToken(token) {
    if (!token) return false

    try {
        // 检查token格式和过期时间
        const payload = JSON.parse(atob(token.split('.')[1]))
        const now = Date.now() / 1000

        // 如果token已过期，返回false
        if (payload.exp && payload.exp < now) {
            return false
        }

        return true
    } catch (error) {
        // 如果token格式不正确，返回false
        return false
    }
}

/**
 * 检查并清理无效的管理员会话
 */
export function checkAndCleanAdminSession() {
    const token = Cookies.get('admin_token')

    if (token && !isValidToken(token)) {
        clearAdminSession()
        return false
    }

    return !!token
}
